<template lang="pug">
el-container
  el-header(height="80px")
    el-menu#elMenu.el-menu-demo(:default-active="activeIndex", mode="horizontal", @select="handleSelect")
      el-menu-item(@click="back()") 后退
      el-menu-item(index="/") 首页
      el-menu-item(index="/admin/userControl") 用户管理
      el-menu-item(index="/admin/socket", v-if="isAdmin") 上传记录
      el-menu-item(index="/admin/historyScenarioControl", v-if="isAdmin") 历史场景管理
      el-menu-item(index="/admin/dataHistory", v-if="isAdmin") 数据历史
      el-menu-item(index="/admin/historyAccessControl") 数据历史访问审批
      el-menu-item(index="/admin/socketCommStatusControl") 连接状态
    HeaderTime(bridgeName="BEIJING")
  el-main(:class="backgroundClass")
    router-view
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "adminLayout",
  data() {
    return {
      activeIndex: "",

      backgroundClass: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

    if (this.activeIndex.indexOf("dataHistory") >= 0) {
      this.backgroundClass = ["admin-white"];
    } else {
      this.backgroundClass = ["admin-bg"];
    }

    document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  computed: {
    ...mapGetters({
      isAdmin: "getIsAdmin",
    }),
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;

      if (this.activeIndex.indexOf("dataHistory") >= 0) {
        this.backgroundClass = ["admin-white"];
      } else {
        this.backgroundClass = ["admin-bg"];
      }
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>


    <style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;
  display: none;
}
</style>